import { Select } from "antd";
import { useEffect, useState } from "react";
import { SizeType } from "antd/es/config-provider/SizeContext";
import { useSelector } from "react-redux";
import store from "../../../../controllers/store";
import { find } from "../../../../controllers/store/actions/groups/get-groups-actions";
import { PageSetting } from "../../..";

interface Props {
  onChange: (value: string) => void;
  size?: SizeType;
  onClear: () => void;
  mode?: any;
  defaultValue?: string;
  style?: any;
}
const dispatch = store.dispatch;
const SelectGroup = (props: Props) => {
  const groupsState = useSelector((state: any) => state.groups);
  const userState = useSelector((state: any) => state.user);

  useEffect(() => {
    if (userState.user.me.role.name === "Admin") {
      dispatch(
        find(PageSetting.page, -1, {
          filter: {},
        })
      );
    } else {
      dispatch(find(PageSetting.page, -1, { filter: {} }));
    }
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <Select
        {...props}
        loading={groupsState.isLoading}
        allowClear
        mode={props?.mode}
        size={props.size}
        defaultValue={props?.defaultValue || []}
        style={props.style}
        onChange={(value: any) => {
          props.onChange(value);
        }}
        options={groupsState.list.map((e: any) => ({
          label: e.nme_grupo_gr,
          value: e.id,
        }))}
      />
    </div>
  );
};

export default SelectGroup;
